/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_Inquiry_BtnInputs */

const en_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make an Inquiry`)
};

const es_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacer una consulta`)
};

const fr_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire une demande`)
};

const de_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfrage stellen`)
};

const ja_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問い合わせる`)
};

const zh_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行咨询`)
};

const ar_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال استفسار`)
};

const id_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim Pertanyaan`)
};

const it_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai una Richiesta`)
};

const ru_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сделать запрос`)
};

const pt_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma Pergunta`)
};

const ko_storefront_inquiry_btn = /** @type {(inputs: Storefront_Inquiry_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의하기`)
};

/**
* | output |
* | --- |
* | "Make an Inquiry" |
*
* @param {Storefront_Inquiry_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_inquiry_btn = /** @type {((inputs?: Storefront_Inquiry_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_Inquiry_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_inquiry_btn(inputs)
	if (locale === "es") return es_storefront_inquiry_btn(inputs)
	if (locale === "fr") return fr_storefront_inquiry_btn(inputs)
	if (locale === "de") return de_storefront_inquiry_btn(inputs)
	if (locale === "ja") return ja_storefront_inquiry_btn(inputs)
	if (locale === "zh") return zh_storefront_inquiry_btn(inputs)
	if (locale === "ar") return ar_storefront_inquiry_btn(inputs)
	if (locale === "id") return id_storefront_inquiry_btn(inputs)
	if (locale === "it") return it_storefront_inquiry_btn(inputs)
	if (locale === "ru") return ru_storefront_inquiry_btn(inputs)
	if (locale === "pt") return pt_storefront_inquiry_btn(inputs)
	return ko_storefront_inquiry_btn(inputs)
});